import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <div className="about__container">
        <h1 className="about__title">About ChoiceRealms</h1>
        <section className="about__section">
          <h2 className="about__subtitle">Our Mission</h2>
          <p className="about__text">
            ChoiceRealms is dedicated to bringing the immersive world of tabletop role-playing games to the digital realm. We aim to create a platform where players can embark on epic adventures, forge lasting friendships, and unleash their creativity in richly detailed fantasy worlds.
          </p>
        </section>
        <section className="about__section">
          <h2 className="about__subtitle">What We Offer</h2>
          <ul className="about__list">
            <li>Immersive online D&D-style gameplay</li>
            <li>AI-driven Dungeon Master for dynamic storytelling</li>
            <li>Character creation and management tools</li>
            <li>Multiple game modules with varied themes and challenges</li>
            <li>Multiplayer functionality for collaborative adventures</li>
            <li>A vibrant community of like-minded adventurers</li>
          </ul>
        </section>
        <section className="about__section">
          <h2 className="about__subtitle">Our Story</h2>
          <p className="about__text">
            Founded by a group of passionate gamers and technologists, ChoiceRealms was born from the desire to make tabletop role-playing games more accessible and engaging in the digital age. We combined our love for classic RPGs with cutting-edge AI technology to create a unique gaming experience that captures the essence of traditional tabletop games while offering the convenience and enhanced features of an online platform.
          </p>
        </section>
        <section className="about__section">
          <h2 className="about__subtitle">Join the Adventure</h2>
          <p className="about__text">
            Whether you're a seasoned dungeon crawler or new to the world of role-playing games, ChoiceRealms welcomes you to join our growing community. Create your character, choose your path, and let the adventures begin!
          </p>
          <a href="/signup" className="about__cta btn btn-primary">Start Your Journey</a>
        </section>
      </div>
    </div>
  );
};

export default About;
